import Swal from "sweetalert2"
import { api_getAddrCityList, api_getAddrDistList } from "../../api/apiAddr"
import { api_getInChargeDistributionList, api_getInChargeSalesList } from "../../api/Beer/apiInCharge"
import { ACTIVATION_ENABLE } from "../MyStat/ItemMyStatBase"

export const RetailInChargeType_Sales = 1
export const RetailInChargeType_Distribution = 2

export const PURVIEW_MANAGER = 1        //業務部主管
export const PURVIEW_SPECIALIST = 2     //業務部專員
export const PURVIEW_DISTRIBUTOR = 3    //經銷商

export function getPurviewString(purview) {
    switch (purview) {
        case PURVIEW_MANAGER:
            return "M"
        case PURVIEW_SPECIALIST:
            return "S"
        case PURVIEW_DISTRIBUTOR:
            return "D"
        default:
            return "D"
    }
}

export class ReqRetailList {
    constructor({ start, limit, RetailName = "", RetailActivation = ACTIVATION_ENABLE, InChargeSales = "", InChargeDistribution = "", RetailAddrCity = "", RetailAddrDist = "" }) {
        this.start = start
        this.limit = limit
        this.RetailName = RetailName
        this.RetailActivation = RetailActivation
        this.InChargeSales = InChargeSales
        this.InChargeDistribution = InChargeDistribution
        this.RetailAddrCity = RetailAddrCity
        this.RetailAddrDist = RetailAddrDist
    }

    fromJson(jsonData) {
        this.start = jsonData.start || 0
        this.limit = jsonData.limit || 10
        this.RetailName = jsonData.RetailName || ""
        this.RetailActivation = jsonData.RetailActivation || ACTIVATION_ENABLE
        this.InChargeSales = jsonData.InChargeSales || ""
        this.InChargeDistribution = jsonData.InChargeDistribution || ""
        this.RetailAddrCity = jsonData.RetailAddrCity || ""
        this.RetailAddrDist = jsonData.RetailAddrDist || ""
    }

}

export class ReqRetailDetail {
    constructor({ RetailID }) {
        this.RetailID = RetailID
    }
    fromJson(jsonData) {
        this.RetailID = jsonData.RetailID
    }
}

export const TITLE_RETAILID = ''
export const TITLE_RetailName = '客戶名稱'
export const TITLE_RetailContact = '聯絡窗口'
export const TITLE_RetailHNKID = 'HNK ID'
export const TITLE_RetailPhone = '聯絡電話'
export const TITLE_RetailAddrCity = '所在縣市'
export const TITLE_RetailAddrDist = '所在區市'
export const TITLE_RetailAddr = '完整地址'
export const TITLE_RetailNote = '備註'
export const TITLE_RetailActivation = '客戶啟停用'
export const TITLE_RetailActivationLastDate = '啟停用異動日期'

export const TITLE_InChargeSales = '所屬業務專員'
export const TITLE_InChargeDistribution = '所屬經銷商'

export const TITLE_prompt = '提示'


export function getAddrCityList(setIsLoading, set_AddrCityList) {
    console.log('getAddrCityList')
    setIsLoading(true)
    api_getAddrCityList({
        success: (jsonData) => {
            // console.log(jsonData)
            set_AddrCityList(jsonData.list)
            setIsLoading(false)
        },
        failure: (err) => {
            console.log(err)
            setIsLoading(false)
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: err,
            })
        }
    })
}

export function getAddrDistList(AddrCityID, setIsLoading, set_AddrDistList) {
    console.log(AddrCityID)
    if (setIsLoading !== undefined)
        setIsLoading(true)
    api_getAddrDistList({
        AddrCityID,
        success: (jsonData) => {
            // console.log(jsonData)
            set_AddrDistList(jsonData.list)
            if (setIsLoading !== undefined)
                setIsLoading(false)
        },
        failure: (err) => {
            console.log(err)
            if (setIsLoading !== undefined)
                setIsLoading(false)
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: err,
            })
        }
    })
}

export function getInChargeSalesList(companyId, setIsLoading, set_InChargeSalesList) {
    setIsLoading(true)
    api_getInChargeSalesList({
        companyId,
        success: (jsonData) => {
            console.log(jsonData)
            set_InChargeSalesList(jsonData.list)
            setIsLoading(false)
        },
        failure: (err) => {
            console.log(err)
            setIsLoading(false)
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: err,
            })
        }
    })
}

export function getInChargeDistributionList(companyId, setIsLoading, set_InChargeDistributionList) {
    setIsLoading(true)
    api_getInChargeDistributionList({
        companyId,
        success: (jsonData) => {
            // console.log(jsonData)
            set_InChargeDistributionList(jsonData.list)
            setIsLoading(false)
        },
        failure: (err) => {
            console.log(err)
            setIsLoading(false)
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: err,
            })
        }
    })
}

export class RespRetail {
    constructor({
        RetailID,
        RetailName,
        RetailHNKID,
        RetailContact,
        RetailPhone,
        RetailAddrCity,
        RetailAddrDist,
        RetailAddr,
        RetailNote,
        InChargeSales,
        InChargeDistribution,
        RetailActivation,
        RetailActivationLastDate
    }) {
        this.RetailID = RetailID
        this.RetailName = RetailName
        this.RetailHNKID = RetailHNKID
        this.RetailContact = RetailContact
        this.RetailPhone = RetailPhone
        this.RetailAddrCity = RetailAddrCity
        this.RetailAddrDist = RetailAddrDist
        this.RetailAddr = RetailAddr
        this.RetailNote = RetailNote
        this.InChargeSales = InChargeSales
        this.InChargeDistribution = InChargeDistribution
        this.RetailActivation = RetailActivation
        this.RetailActivationLastDate = RetailActivationLastDate
    }

    fromJson(jsonData) {
        this.id = jsonData._id
        this.RetailID = jsonData.RetailID
        this.RetailName = jsonData.RetailName
        this.RetailHNKID = jsonData.RetailHNKID
        this.RetailContact = jsonData.RetailContact
        this.RetailPhone = jsonData.RetailPhone
        this.RetailAddrCity = jsonData.RetailAddrCity
        this.RetailAddrCityName = jsonData.RetailAddrCityName
        this.RetailAddrDist = jsonData.RetailAddrDist
        this.RetailAddrDistName = jsonData.RetailAddrDistName
        this.RetailAddr = jsonData.RetailAddr
        this.RetailNote = jsonData.RetailNote
        this.InChargeSales = jsonData.InChargeSales
        this.InChargeSalesName = jsonData.InChargeSalesName
        this.InChargeDistribution = jsonData.InChargeDistribution
        this.InChargeDistributionName = jsonData.InChargeDistributionName
        this.RetailActivation = jsonData.RetailActivation
        this.RetailActivationLastDate = jsonData.RetailActivationLastDate
    }
}

/**客戶歸屬資料 */
export class RespRetailInCharge {
    constructor({
        RetailInChargeID,
        RetailInChargeType,
        RetailID,
        RetailInChargeStaffID,
        isEffective
    }) {
        this.RetailInChargeID = RetailInChargeID
        this.RetailInChargeType = RetailInChargeType
        this.RetailID = RetailID
        this.RetailInChargeStaffID = RetailInChargeStaffID
        this.isEffective = isEffective
    }

    fromJson(jsonData) {
        this.id = jsonData._id
        this.RetailInChargeID = jsonData.RetailInChargeID
        this.RetailInChargeType = jsonData.RetailInChargeType
        this.RetailID = jsonData.RetailID
        this.RetailInChargeStaffID = jsonData.RetailInChargeStaffID
        this.isEffective = jsonData.isEffective
    }
}

/**客戶機器設備 */
export class RespRetailMachine {
    constructor({
        RetailMachineID,
        RetailID,
        MachineID,
        isEffective
    }) {
        this.RetailMachineID = RetailMachineID
        this.RetailID = RetailID
        this.MachineID = MachineID
        this.isEffective = isEffective
    }

    fromJson(jsonData) {
        this.id = jsonData._id
        this.RetailMachineID = jsonData.RetailMachineID
        this.RetailID = jsonData.RetailID
        this.MachineID = jsonData.MachineID
        this.isEffective = jsonData.isEffective
    }
}